export default __webpack_public_path__ + "static/media/about-us.0e4931ba.jpg";